<div class="footer">
  <div class="copyright-text justify-content-center align-items-center">
    Copyright &copy; 2001-{{ currentYear }} Accenture. All rights reserved.
    Accenture Confidential. For internal use only.
    <a
      href="https://www.accenture.com/us-en/support/terms-of-use"
      target="_blank"
      title="Terms of Use"
      class="terms-of-use"
      >Terms of Use</a
    >
    |
    <a
      href="https://www.accenture.com/us-en/about/privacy-policy"
      target="_blank"
      title="Privacy Statement"
      class="privacy-statement"
    >
      Privacy Statement
    </a>
    <!-- <a
      href="mailto:myNavIndustry.Support@accenture.com"
      target="_blank"
      title="Contact Us"
    >
      Contact Us
    </a> -->
  </div>
</div>